import styled from 'styled-components';

export const Contain = styled.div``;

export const List = styled.div`
  min-height: calc(100vh - 229px);
`;

export default {
  panel: {
    'height': 'calc(100% - 35px)',
    'overflowY': 'scroll'
  }
}

export const Container = styled.div``;

export const Row = styled.div`
  display: flex;
  margin-left: -10px;
  margin-right: -10px;
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

export const Col = styled.div`
  flex: 1;
  padding: 7.5px 10px;
`;
export const PageContainer = styled.div`
  margin: 15px 0;
`;
